import * as React from "react";

export const Filter = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3999 4.00002C1.3999 3.66865 1.66853 3.40002 1.9999 3.40002H13.9999C14.3313 3.40002 14.5999 3.66865 14.5999 4.00002C14.5999 4.3314 14.3313 4.60002 13.9999 4.60002H1.9999C1.66853 4.60002 1.3999 4.3314 1.3999 4.00002ZM3.7999 8.00002C3.7999 7.66865 4.06853 7.40002 4.3999 7.40002H11.5999C11.9313 7.40002 12.1999 7.66865 12.1999 8.00002C12.1999 8.3314 11.9313 8.60002 11.5999 8.60002H4.3999C4.06853 8.60002 3.7999 8.3314 3.7999 8.00002ZM6.1999 12C6.1999 11.6687 6.46853 11.4 6.7999 11.4H9.1999C9.53127 11.4 9.7999 11.6687 9.7999 12C9.7999 12.3314 9.53127 12.6 9.1999 12.6H6.7999C6.46853 12.6 6.1999 12.3314 6.1999 12Z"
    />
);
